import { Trash } from "@phosphor-icons/react";
import {
  ENTRY_META,
  formatTime,
  summariseEntry,
} from "@/lib/entryTypes";

/**
 * Renders a single entry row. When `onDelete` is provided a trash button is
 * shown (teacher view only).
 */
export default function EntryCard({ entry, onDelete }) {
  const meta = ENTRY_META[entry.entry_type] || ENTRY_META.note;
  const Icon = meta.icon;
  return (
    <div
      data-testid={`entry-card-${entry.id}`}
      data-entry-type={entry.entry_type}
      className="flex items-start gap-3 rounded-2xl border border-neutral-200 bg-white p-4"
    >
      <div
        className={`flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl ${meta.bg}`}
      >
        <Icon size={20} weight="duotone" className={meta.color} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center justify-between gap-2">
          <p className="text-[11px] font-bold uppercase tracking-[0.15em] text-neutral-500">
            {entry.detail?.food_program ? `${meta.label} · Food program` : meta.label}
          </p>
          <p className="text-xs text-neutral-500">
            {entry.detail?.food_program ? "Recorded for this day" : formatTime(entry.occurred_at)}
          </p>
        </div>
        <p className="mt-0.5 text-sm font-medium text-neutral-900">
          {summariseEntry(entry)}
        </p>
        {entry.detail?.notes && (
          <p className="mt-1 text-xs text-neutral-600">{entry.detail.notes}</p>
        )}
        {entry.detail?.description && (
          <p className="mt-1 text-xs text-neutral-600">{entry.detail.description}</p>
        )}
      </div>
      {onDelete && (
        <button
          data-testid={`entry-delete-${entry.id}`}
          onClick={() => onDelete(entry)}
          className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full text-neutral-400 transition-all hover:bg-neutral-100 hover:text-primary-hover"
          aria-label="Delete entry"
        >
          <Trash size={16} weight="duotone" />
        </button>
      )}
    </div>
  );
}
